import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Gates a route by module entitlement. If the user's tier doesn't include the
// module, the route is hidden entirely — redirect Home (nav also hides it).
export function ModuleRoute({ module, children }) {
  const { hasModule, entitlements } = useAuth();
  if (!entitlements) return null;
  if (!hasModule(module)) return <Navigate to="/" replace />;
  return children;
}
